export class SubscriptionManager {
  subscriptions = [];

  subscribe(obs$, callback, onError = undefined) {
    const sub = obs$.subscribe(callback, onError);
    this.subscriptions.push(sub);
    return sub;
  }

  unsubscribe(sub) {
    sub.unsubscribe();
    const index = this.subscriptions.indexOf(sub);
    if (index >= 0) {
      this.subscriptions.splice(index, 1);
    }
  }

  destroy() {
    // eslint-disable-next-line
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions.length = 0;
  }
}
